import PropTypes from 'prop-types'

function SettingsSelect({
  label,
  description,
  value,
  onChange,
  options = [],
  disabled = false,
  required = false,
  className = '',
}) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-neutral-900 dark:text-white mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {description && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-2">{description}</p>
      )}
      <select
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className="w-full px-3 py-2 border border-neutral-300 dark:border-neutral-600 rounded-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed [&>option]:bg-white [&>option]:text-neutral-900 dark:[&>option]:bg-neutral-800 dark:[&>option]:text-white"
        style={{
          // Additional styles for better cross-browser compatibility
          colorScheme: 'light dark',
        }}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            className="bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

SettingsSelect.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
}

export default SettingsSelect
